<template>
  <v-dialog
    v-model="internalDialog"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-actions class="justify-end">
        <v-icon
          text
          @click="handleClose"
        >
          mdi-close-thick
        </v-icon>
      </v-card-actions>
      <v-toolbar
        dark
        style="background-color:rgb(204 33 40);color:white !important"
      >
        <strong>Cambiar Estado de Factura</strong> - {{ invoiceItem.prefix }}-{{ invoiceItem.consecutive }}
      </v-toolbar>

      <v-card-text style="padding-top: 20px;">
        <v-form
          ref="form"
          v-model="formValid"
        >
          <v-row>
            <v-col cols="12">
              <v-alert
                type="info"
                dense
                outlined
              >
                <strong>Estado actual:</strong> {{ currentStatusLabel }}
              </v-alert>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-select
                v-model="newStatus"
                :items="availableTransitions"
                item-text="label"
                item-value="value"
                label="Nuevo Estado *"
                prepend-inner-icon="mdi-swap-horizontal"
                outlined
                dense
                :rules="[v => !!v || 'Seleccione un estado']"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="motivo"
                label="Motivo del cambio *"
                prepend-inner-icon="mdi-comment-text"
                outlined
                dense
                rows="3"
                counter="500"
                maxlength="500"
                :rules="[
                  v => !!v || 'El motivo es obligatorio',
                  v => (v && v.length >= 10) || 'Minimo 10 caracteres'
                ]"
              />
            </v-col>
          </v-row>

          <v-row v-if="msgResponse">
            <v-col cols="12">
              <v-alert
                :type="alertType"
                text
              >
                {{ msgResponse }}
              </v-alert>
            </v-col>
          </v-row>

          <v-row
            v-if="progress"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col cols="6">
              <v-col
                class="text-subtitle-1 text-center"
                cols="12"
              >
                Cambiando estado de factura
              </v-col>
              <v-progress-linear
                color="red darken-4"
                indeterminate
                rounded
                height="6"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="handleClose"
        >
          Cancelar
        </v-btn>
        <v-btn
          :style="(!isFormValid || progress) ? 'background-color: #9e9e9e; color: white !important' : 'background-color: rgb(204 33 40); color: white !important'"
          :disabled="!isFormValid || progress"
          @click="confirmChange"
        >
          <v-icon left>
            mdi-check-circle
          </v-icon>
          Confirmar Cambio
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getValidTransitions, statusLabels } from '@/data/statusTransitions'

export default {
  name: 'ChangeStatusModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    invoiceItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      newStatus: null,
      motivo: '',
      progress: false,
      msgResponse: '',
      alertType: 'success',
      formValid: false
    }
  },
  computed: {
    internalDialog: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    currentStatusLabel() {
      return statusLabels[this.invoiceItem.status] || this.invoiceItem.status || ''
    },
    availableTransitions() {
      const transitions = getValidTransitions(this.invoiceItem.status)
      return transitions.map(status => ({
        value: status,
        label: statusLabels[status] || status
      }))
    },
    isFormValid() {
      return this.formValid && this.newStatus && this.motivo && this.motivo.length >= 10
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.newStatus = null
      this.motivo = ''
      this.msgResponse = ''
      this.progress = false
      this.alertType = 'success'
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    handleClose() {
      this.msgResponse = ''
      this.progress = false
      this.alertType = 'success'
      this.$emit('close')
    },
    async confirmChange() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.progress = true
      this.msgResponse = ''
      this.alertType = 'success'

      try {
        const payload = {
          IdCompania: this.invoiceItem.company_id,
          Prefijo: this.invoiceItem.prefix,
          Consecutivo: this.invoiceItem.consecutive,
          estadoActual: this.invoiceItem.status,
          estadoNuevo: this.newStatus,
          motivo: this.motivo
        }

        const newStatusLabel = statusLabels[this.newStatus] || this.newStatus

        await this.$store.dispatch('invoice/changeInvoiceStatus', payload)

        this.progress = false
        this.alertType = 'success'
        this.msgResponse = `Estado cambiado exitosamente a "${newStatusLabel}"`

        setTimeout(() => {
          this.$emit('status-changed', {
            invoice: this.invoiceItem,
            oldStatus: this.invoiceItem.status,
            newStatus: this.newStatus
          })
          this.handleClose()
        }, 2000)
      } catch (error) {
        this.progress = false
        this.alertType = 'error'
        this.msgResponse = error.message || 'Error al cambiar el estado de la factura'
        console.error(error)
      }
    }
  }
}
</script>
